const variants = {
  "x-50-stagger-parent": {
    visible: {
      opacity: 1,
      transition: {
        when: "beforeChildren",
        staggerChildren: 0.05,
      },
    },
    hidden: {
      opacity: 0,
      transition: {
        when: "afterChildren",
      },
    },
  },
  "x-50-stagger-child": {
    visible: {
      opacity: 1,
      x: 0,
    },
    hidden: { opacity: 0, x: -50 },
  },
}

const animeprops = {
  "fade-in": {
    initial: { opacity: 0 },
    animate: { opacity: 1, transition: { duration: 0.25 } },
  },
  "skeleton-flash": {
    initial: { backgroundColor: "#f7fafc" },
    animate: {
      backgroundColor: "#edf2f7",
      transition: { yoyo: Infinity, duration: 0.5 },
    },
  },
  "y-spring-100": {
    initial: { opacity: 0, y: -100 },
    animate: {
      opacity: 1,
      y: 0,
      transition: { type: "spring", stiffness: 100, duration: 0.1 },
    },
  },
  "x-50-stagger-parent": {
    initial: "hidden",
    animate: "visible",
    variants: variants["x-50-stagger-parent"],
  },
  "x-50-stagger-child": {
    variants: variants["x-50-stagger-child"],
  },
}

export default animeprops
